import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'flowbite-react';
import './styles/global/index.css';
import App from './App';
import RefRouter from './router/RefRouter';
import reportWebVitals from './reportWebVitals';
import { flowbiteTheme } from './theme/flowbite-theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={flowbiteTheme}>
      <RefRouter>
        <App />
      </RefRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
